// extracted by mini-css-extract-plugin
export var centerText = "_ch-8";
export var container = "_ch-0";
export var doughnutContainer = "_ch-7";
export var legend = "_ch-a";
export var legendItemColorDisplay = "_ch-b";
export var legendItemLabel = "_ch-d";
export var legendItemValue = "_ch-c";
export var lg = "_ch-5";
export var maxWidth = "_ch-9";
export var md = "_ch-4";
export var responsive = "_ch-6";
export var sm = "_ch-3";
export var xs = "_ch-2";
export var xxs = "_ch-1";